// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o01ZIgwjVCFq6Ah31kJU {
	display: flex;
	flex-direction: column;
}
.TtzjaTdd577Y1hy038Kr {
	margin-bottom: 5px;
}
.hKH5QBGQOz0fWgK7tZOu {
	margin: 6px 0px;
}
@media (max-width: 767px) {
	.hj7eGbCTo7vgTkThWCJ7 {
		margin-bottom: 25px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/CrossChainFarmPage/TotalRewardsBalance.pcss"],"names":[],"mappings":"AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC;EACC,mBAAmB;CACpB;AACD","sourcesContent":["@import '../../stylesheets/media-queries.pcss';\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.title {\n\tmargin-bottom: 5px;\n}\n\n.spinner {\n\tmargin: 6px 0px;\n}\n\n@media (--mobile) {\n\t.value {\n\t\tmargin-bottom: 25px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `o01ZIgwjVCFq6Ah31kJU`,
	"title": `TtzjaTdd577Y1hy038Kr`,
	"spinner": `hKH5QBGQOz0fWgK7tZOu`,
	"value": `hj7eGbCTo7vgTkThWCJ7`
};
export default ___CSS_LOADER_EXPORT___;
